<template>
  <div class='fixed'>
    <div class='wrapHeader'>
      <el-form :inline="true" :model="fiexdSelect" class="demo-form-inline">
        <el-form-item label="设备名称">
          <el-input v-model="fiexdSelect.serName" placeholder="输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="设备识别码">
          <el-input v-model="fiexdSelect.simId" placeholder="输入设备识别码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="selectMac">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' :style='`height:${height}px`'>
      <div class='publicWrap'>
        <div class='showView' :style="`height:${height-20}px;width:${width-30}px`">
          <div class='setTabView' :style="`height:${height-50}px;width:${width-60}px`">
            <el-tabs v-model="activeName" type="card" class='delmarg' @tab-click="setMacTypeInfo" :before-leave='emptyMacList'>
              <el-tab-pane label="4G分机" name="tab1">
                <div class='commonWareList' :style="`height:${height-115}px`">
                  <div class='commonItem fixedMac' v-for='item in macList' :key='item.serId'>
                    <div class='fixedHead'>
                      <div class='fiexdMacName'>{{item.serName}}</div>
                      <div style="font-weight:400">{{item.simId}}</div>
                    </div>
                    <div class='fixedImgWrap'>
                      <div>
                        <div class='setGrainMacImg extension'></div>
                      </div>
                      <div>
                        <div class='fixedStatus'>
                          <span>在线状态：</span>
                          <div :class='["wifi",item.status==0?"offLine":"onLine"]'>{{item.status==0?'离线':'在线'}}</div>
                        </div>
                        <div class='fixedStatus'>
                          <span>RSSI：</span>
                          <div class="wifi">{{item.serInfo.rssi}}</div>
                        </div>
                        <div class='fixedStatus'>
                          <span>电池电量：</span>
                          <div class=powerWrap>
                            <div :class='["macPower",item.serInfo.status=="充电中"?"macCharge":"macDischarge"]'></div>
                            <div class='powerInfoWrap' v-if='item.serInfo.status!="充电中"'>
                              <div class='powerInfo' :style='`width:${item.serInfo.batteryLevel?item.serInfo.batteryLevel:0}%`'></div>
                            </div>
                            <div class='powerText' style="width:25px;text-align:center">{{item.serInfo.batteryLevel}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class='fixedMacInfo'>
                      <div>
                        <div class='fixedMacInfo-wrap fixedMacInfo-bg'><span class='fixedMacInfo-title'>电池电压</span><span class='fixedMacInfo-value'>{{item.serInfo.batteryVoltage}}V</span></div>
                        <div class='fixedMacInfo-wrap'><span class='fixedMacInfo-title'>太阳能电压</span><span class='fixedMacInfo-value'>{{item.serInfo.solarPanelVoltage}}V</span></div>
                        <div class='fixedMacInfo-wrap fixedMacInfo-bg'><span class='fixedMacInfo-title'>激活状态</span><span class='fixedMacInfo-value'>{{item.serInfo.message}}</span></div>
                      </div>
                      <div>
                        <div class='fixedMacInfo-wrap fixedMacInfo-bg'><span class='fixedMacInfo-title'>剩余流量</span><span class='fixedMacInfo-value'>{{item.serInfo.surplus}} M</span></div>
                        <div class='fixedMacInfo-wrap'><span class='fixedMacInfo-title'>软件版本</span><span class='fixedMacInfo-value'>{{item.serInfo.version}}</span></div>
                        <div class='fixedMacInfo-wrap fixedMacInfo-bg'><span class='fixedMacInfo-title'>卡有效期</span><span class='fixedMacInfo-value'>{{item.serInfo.expiredAt}}</span></div>
                      </div>
                    </div>
                    <div class="fixedBtn">
                      <el-button size="mini" type="primary" @click='debug(item.simId)'>调试</el-button>
                      <el-button size="mini" type="danger" @click='resetMac(item.serId)'>重启</el-button>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="4G主机" name="tab2">
                <div class='commonWareList' :style="`height:${height-115}px`">
                  <div class='commonItem fixedMac' v-for='item in macList' :key='item.serId'>
                    <div class='fixedHead'>
                      <div class='fiexdMacName'>{{item.serName}}</div>
                      <div style="font-weight:400">{{item.simId}}</div>
                    </div>
                    <div class='fixedImgWrap'>
                      <div>
                        <div class='setGrainMacImg host'></div>
                      </div>
                      <div>
                        <div class='fixedStatus'>
                          <span>在线状态：</span>
                          <div :class='["wifi",item.status==0?"offLine":"onLine"]'>{{item.status==0?'离线':'在线'}}</div>
                        </div>
                        <div class='fixedStatus'>
                          <span>RSSI：</span>
                          <div class="wifi">{{item.serInfo.rssi}}</div>
                        </div>
                        <div class='fixedStatus'>
                          <span>电池电量：</span>
                          <div class=powerWrap>
                            <div :class='["macPower",item.serInfo.status=="充电中"?"macCharge":"macDischarge"]'></div>
                            <div class='powerInfoWrap' v-if='item.serInfo.status!="充电中"'>
                              <div class='powerInfo' :style='`width:${item.serInfo.batteryLevel?item.serInfo.batteryLevel:0}%`'></div>
                            </div>
                            <div class='powerText' style="width:25px;text-align:center">{{item.serInfo.batteryLevel}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class='fixedMacInfo'>
                      <div>
                        <div class='fixedMacInfo-wrap fixedMacInfo-bg'><span class='fixedMacInfo-title'>电池电压</span><span class='fixedMacInfo-value'>{{item.serInfo.batteryVoltage}}V</span></div>
                        <div class='fixedMacInfo-wrap'><span class='fixedMacInfo-title'>太阳能电压</span><span class='fixedMacInfo-value'>{{item.serInfo.solarPanelVoltage}}V</span></div>
                        <div class='fixedMacInfo-wrap fixedMacInfo-bg'><span class='fixedMacInfo-title'>激活状态</span><span class='fixedMacInfo-value'>{{item.serInfo.message}}</span></div>
                      </div>
                      <div>
                        <div class='fixedMacInfo-wrap fixedMacInfo-bg'><span class='fixedMacInfo-title'>剩余流量</span><span class='fixedMacInfo-value'>{{item.serInfo.surplus}} M</span></div>
                        <div class='fixedMacInfo-wrap'><span class='fixedMacInfo-title'>软件版本</span><span class='fixedMacInfo-value'>{{item.serInfo.version}}</span></div>
                        <div class='fixedMacInfo-wrap fixedMacInfo-bg'><span class='fixedMacInfo-title'>卡有效期</span><span class='fixedMacInfo-value'>{{item.serInfo.expiredAt}}</span></div>
                      </div>
                    </div>
                    <div class="fixedBtn">
                      <el-button size="mini" type="danger" @click='resetMac(item.serId)'>重启</el-button>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="4G气象站" name="tab3">
                <div class='commonWareList' :style="`height:${height-115}px`">
                  <div class='commonItem fixedMac' v-for='item in macList' :key='item.serId' v-if='item.stationType==0'>
                    <div class='fixedHead'>
                      <div class='fiexdMacName'>{{item.serName}}</div>
                      <div style="font-weight:400">{{item.simId}}</div>
                    </div>
                    <div class='fixedImgWrap'>
                      <div>
                        <div class='setGrainMacImg weather'></div>
                      </div>
                      <div>
                        <div class='fixedStatus'>
                          <span>在线状态：</span>
                          <div :class='["wifi",item.status==0?"offLine":"onLine"]'>{{item.status==0?'离线':'在线'}}</div>
                        </div>
                        <div class='fixedStatus'>
                          <span>RSSI：</span>
                          <div class="wifi">{{item.serInfo.rssi}}</div>
                        </div>
                        <div class='fixedStatus'>
                          <span>电池电量：</span>
                          <div class=powerWrap>
                            <div :class='["macPower",item.serInfo.status=="充电中"?"macCharge":"macDischarge"]'></div>
                            <div class='powerInfoWrap' v-if='item.serInfo.status!="充电中"'>
                              <div class='powerInfo' :style='`width:${item.serInfo.batteryLevel?item.serInfo.batteryLevel:0}%`'></div>
                            </div>
                            <div class='powerText' style="width:25px;text-align:center">{{item.serInfo.batteryLevel}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class='fixedMacInfo'>
                      <div>
                        <div class='fixedMacInfo-wrap fixedMacInfo-bg'><span class='fixedMacInfo-title'>电池电压</span><span class='fixedMacInfo-value'>{{item.serInfo.batteryVoltage}}V</span></div>
                        <div class='fixedMacInfo-wrap'><span class='fixedMacInfo-title'>太阳能电压</span><span class='fixedMacInfo-value'>{{item.serInfo.solarPanelVoltage}}V</span></div>
                        <div class='fixedMacInfo-wrap fixedMacInfo-bg'><span class='fixedMacInfo-title'>激活状态</span><span class='fixedMacInfo-value'>{{item.serInfo.message}}</span></div>
                      </div>
                      <div>
                        <div class='fixedMacInfo-wrap fixedMacInfo-bg'><span class='fixedMacInfo-title'>剩余流量</span><span class='fixedMacInfo-value'>{{item.serInfo.surplus}} M</span></div>
                        <div class='fixedMacInfo-wrap'><span class='fixedMacInfo-title'>软件版本</span><span class='fixedMacInfo-value'>{{item.serInfo.version}}</span></div>
                        <div class='fixedMacInfo-wrap fixedMacInfo-bg'><span class='fixedMacInfo-title'>卡有效期</span><span class='fixedMacInfo-value'>{{item.serInfo.expiredAt}}</span></div>
                      </div>
                    </div>
                    <div class="fixedBtn">
                      <el-button size="mini" type="danger" @click='resetMac(item.serId)'>重启</el-button>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :hide-on-single-page='true'
              :pageSize='fiexdSelect.pageSize' 
              :current-page='fiexdSelect.pageNum'
              @current-change='getOtherMac'
              class='setPosition2'>
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog 
      title="分机状态" 
      :visible.sync="fixedShow" 
      top='100px'
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg dialog-setWare-bg"'>
      <div class='formWrap'>
        <el-form ref="fixedInfo" :model="fixedInfo" label-width="100px" class='fixedInfoForm'>
          <div class='dialog-setWare-wrap'>
            <div class='baseInfoTitle' style="padding-top:10px"><span></span>选择分机</div>
            <div class='dialog-setWrap wareBaseInfo'>
              <el-form-item label="分机名称">
                <el-select 
                  v-model="fixedInfo.simId" 
                  @change='extensionChange'
                  placeholder="请选择分机">
                  <el-option 
                    :label="item.serName" 
                    :value="item.simId" 
                    v-for='item in extensionList' 
                    :key='item.simId'>
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="仓房名称">
                <el-select 
                  v-model="fixedInfo.wareId" 
                  @change='wareChange'
                  placeholder="请选择仓房">
                  <el-option 
                    :label="item.wareName" 
                    :value="item.wareId" 
                    v-for='item in wareList' 
                    :key='item.wareId'>
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="检测通道">
                <el-select v-model="fixedInfo.channel" placeholder="请选择通道">
                  <el-option 
                    :label="`第${item}通道`" 
                    :value="item-1" 
                    v-for='item in 8' 
                    :key='item'>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="读取传感器ID">
                <el-radio-group v-model="fixedInfo.readID">
                  <el-radio label="0">不读取</el-radio>
                  <el-radio label="1">读取</el-radio>
                </el-radio-group>
              </el-form-item>  
              <!-- <el-form-item label="电缆列号" v-if='fixedInfo.discernMode==0'>
                <el-input v-model="fixedInfo.column" placeholder="电缆列号"></el-input>
              </el-form-item>             -->
            </div>
          </div>
          <div class='baseInfoTitle' style="padding-top:10px"><span></span>分机调试反馈信息</div>
          <div class='feedbackInfo'>
            <div class='msgWrap'>
              <div v-html='msg'></div>
            </div>
          </div>
          <div class='fixedBtnList'>
            <el-button class='fixedBtn' :disabled='clock' type="primary" @click="sendInfo('97')">分机状态</el-button>
            <!-- <el-button class='fixedBtn' :disabled='clock' type="primary" @click="sendInfo('68')">软件版本</el-button>
            <el-button class='fixedBtn' :disabled='clock' type="primary" @click="sendInfo('89')">系统自检</el-button>
            <el-button class='fixedBtn' :disabled='clock' type="primary" @click="sendInfo('137')">传感器编号</el-button> -->
            <el-button class='fixedBtn' :disabled='clock' type="primary" @click="sendInfo('98')">电缆信息</el-button>
            <el-button class='fixedBtn' :disabled='clock' type="danger" @click="clearInfo()">清空内容</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '../../axios.js'
import createSocket from '../../webSocket.js'
export default {
  props:{
    width:Number,
    height:Number
  },
  data(){
    return{
      activeName:'tab1',
      fiexdSelect:{
        serName:'',
        simId:'',
        pageSize:10,
        pageNum:1,
        isAsc:'desc',
        orderByColumn:'serId',
        serType:'DEVBHLW084G'
      },
      macList:[],
      total:0,
      isSwitch:false,
      loading:false,
      updateMacInfo:null,
      fixedInfo:{readID:'0'},
      fixedShow:false,
      extensionList:[],
      wareList:[],
      allWareList:[],
      loading2:false,
      ws:null,
      clock:false,
      msg:''
    }
  },
  created(){
    axios.get('/system/ser/list',{params:{
      serType:'DEVBHLW084G',
      pageSize:1000
    }}).then(res=>{
      if(res){
        this.extensionList=res.rows;
      }
    })
    axios.get('/system/house/list',{params:{pageSize:1000}}).then(res=>{
      if(res){
        this.allWareList=res.rows;
      }
    })
    axios.get('/system/ser/getSerType').then(res=>{
      if(res){
        if(res.data.fExist){
          this.activeName='tab1';
          this.fiexdSelect.serType='DEVBHLW084G';
        }else if(res.data.hostExist){
          this.activeName='tab2';
          this.fiexdSelect.serType='DEVLQSERVER4G';
        }else if(res.data.weatherExist){
          this.activeName='tab3';
          this.fiexdSelect.serType='5';
        }else{
          this.$message({
            type: 'warning',
            message: '暂无4G设备，请添加设备!',
            duration:2000
          });
        }
        this.getMacList();
      }
    });
  },
  destroyed(){
    this.ws.close()
  },
  methods:{
    selectMac(){
      this.getMacList();
      this.isSwitch=true;
    },
    getMacList(){
      axios.get('/system/ser/list',{params:this.fiexdSelect}).then(res=>{
        if(res.code==200){
          this.macList=res.rows;
          this.total=res.total;
        }
      })
    },
    getOtherMac(val){
      this.fiexdSelect.pageNum=val;
      this.getMacList()
    },
    setMacTypeInfo(event){
      this.total=0;
      if(event.index==0){
        this.fiexdSelect.serType='DEVBHLW084G';
        this.fiexdSelect.pageNum=1;
      }else if(event.index==1){
        this.fiexdSelect.serType='DEVLQSERVER4G';
        this.fiexdSelect.pageNum=1;
      }else if(event.index==2){
        this.fiexdSelect.serType=5;
        this.fiexdSelect.pageNum=1;
      }
      this.getMacList()
    },
    emptyMacList(activeName, oldActiveName){
      if(this.isSwitch){
        this.isSwitch=false
      }else{
        this.macList=[];
      }
    },
    setMacLoading(){
      this.loading=this.$loading({
        text:'请稍等',
        target:document.querySelector('.dialog-setBg')
      })
    },
    setLoading(){
      this.loading2=this.$loading({
        text:'请稍等',
        target:document.querySelector('.fixed')
      })
    },
    resetMac(serId){
      this.$confirm('此操作将重启设备, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post('/system/grain/reStart',{serId:serId}).then(data=>{
          if(data){
            this.getMacList()
            this.$message({
              type: 'success',
              message:data.msg,
              duration:1000
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重启',
          duration:1000
        });          
      });
    },
    debug(simId){
      this.socket()
      this.extensionList.forEach(item=>{
        if(item.simId==simId){
          this.wareList=item.wareNameVoList
        }
      })
      this.fixedInfo={
        simId:simId,
        readID:'0'
      };
      this.fixedShow=true;
    },
    socket(){
      this.ws=createSocket('/websocket/serTest')
      this.ws.onmessage=this.wsMessage;
    },
    extensionChange(val){
      this.extensionList.forEach(item=>{
        if(item.simId==val){
          this.wareList=item.wareNameVoList
        }
      })
      this.fixedInfo={
        simId:val,
        readID:"0"
      };
    },
    wareChange(val){
      this.allWareList.forEach(item=>{
        if(item.wareId==val){
          this.fixedInfo.discernMode=item.discernMode
        }
      })
    },
    sendInfo(cmd){
      let params={}
      switch(cmd){
        case '65':
          params={
            simId:this.fixedInfo.simId, 
            cmd:cmd
          }
          break;
        case '68':
          params={
            simId:this.fixedInfo.simId, 
            cmd:cmd
          }
          break;
        case '89':
          params={
            simId:this.fixedInfo.simId, 
            cmd:cmd
          }
          break;
        case '98':
          params={
            simId:this.fixedInfo.simId, 
            cmd:cmd,
            channel:this.fixedInfo.channel,
            readID:this.fixedInfo.readID
          };
          break;
        case '137':
          params={
            simId:this.fixedInfo.simId, 
            cmd:cmd,
            wareId:this.fixedInfo.wareId,
            column:this.fixedInfo.column
          }
          break;
        case '140':
          params={
            simId:this.fixedInfo.simId, 
            cmd:cmd,
            channel:this.fixedInfo.channel
          }
          break;
        default:
          params={
            simId:this.fixedInfo.simId, 
            cmd:cmd
          }
      }
      let josn=JSON.stringify(params);
      if(this.ws.readyState===1){
        this.ws.send(josn);
      }else{
        this.$message({
          type: 'info',
          message: 'websocket正在连接，稍后重试！',
          duration:1000
        });   
      }
    },
    wsMessage(res){
      let data=JSON.parse(res.data);
      this.clock=data.clock;
      this.msg+=data.msg
    },
    clearInfo(){
      this.msg=''
    }
  }
}
</script>

<style scoped lang="scss">
.fixed{
  .fixedMac{
    margin:13px 8px 9px 13px;
    width: 300px;
    height: 268px;
    .fixedHead{
      height: 40px;
      width: 100%;
      background-color: #325dfb;
      position: absolute;
      top: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      box-sizing: border-box;
      font-weight: 600;
      color: white;
      .fiexdMacName{
        font-size: 14px;
      }
      .fixedReset{
        font-size: 20px;
        cursor: pointer;
      }
    }
    .fixedImgWrap{
      width: 100%;
      height: 110px;
      position: absolute;
      top: 40px;
      display: flex;
      .setGrainMacImg{
        height:66px;
        background-size: cover;
      }
      .extension{
        background-image: url('../../assets/grain/extension.png');
        width: 130px;
      }
      .weather{
        width: 85px;
        background-image: url('../../assets/grain/weather.png')
      }
      .host{
        width: 85px;
        background-image: url('../../assets/grain/host.png')
      }
      .fixedStatus{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        font-size: 14px;
        .wifi{
          background-size: cover;
          height: 25px;
          width:30px;
          line-height: 25px;
          margin-right: 5px
        }
        .isLine{
          background-size: cover;
          height: 20px;
          width:20px;
          margin-right: 10px
        }
        .offLine{
          color: #F56C6C;
          
        }
        .onLine{
            color: #3562ff;
        }
        .powerWrap{
          position: relative;
          .macPower{
            background-size: cover;
            height: 30px;
            width:30px
          }
          .macDischarge{
            background-image: url('../../assets/icon/power.png');
          }
          .macCharge{
            background-image: url('../../assets/icon/power.gif');
          }
          .powerInfoWrap{
            position: absolute;
            font-size: 12px;
            top: 9px;
            left: 2px;
            width: 25px;
            height: 12px;
            .powerInfo{
              background: rgb(202, 201, 201);
              height: 100%;
            }
          }
          .powerText{
            position: absolute;
            font-size: 12px;
            top:7px;
            left: 2px;
          }
        }
      }
    }
    .fixedImgWrap>div{
      width: 50%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      font-size: 12px;
      padding: 10px 0;
      box-sizing: border-box
    }
    .fixedMacInfo{
      font-size: 12px;
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      position: absolute;
      top: 150px;
      height: 78px;
      .fixedMacInfo-wrap{
        height: 26px;
        line-height: 26px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .fixedMacInfo-title{
          display:inline-block;
          width: 65px;
          height: 26px;
          text-align: end
        }
        .fixedMacInfo-value{
          display:inline-block;
          width:79px;
          height: 26px;
          padding-right: 5px;
          text-align: end;
          box-sizing: border-box
        }
      }
      .fixedMacInfo-bg{
        background-color: rgba(217,217,217,0.3);
      }
    }
    .fixedMacInfo>div{
      width: 50%;
      border-right: 1px solid rgba(0,0,0,.12);
      box-sizing: border-box
    }
    .fixedMacInfo>div:last-child{
      border: none
    }
    .fixedBtn{
      position: absolute;
      bottom: 0;
      width: 100%;
      box-sizing: border-box;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 10px;
    }
  }
  .dialog-setWrap-fixed{
    flex-wrap: wrap;
    width: 700px !important
  }
  .dialog-setWrap-fixed .el-form-item{
    width: 50%
  }
  .feedbackInfo{
    background: rgba(255,255,255,0.63);
    box-shadow: inset 0 1px 1px 0 #fff,
    0 3px 7px 0 rgba(0,0,0,0.09);
    border-radius: 8px;
    width: 700px;
    height: 400px;
    padding: 10px;
    box-sizing: border-box;
    font-size: 14px;
    .msgWrap{
      width: 680px;
      height: 380px;
      overflow: auto;
    }
  }
  .fixedBtnList{
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .fixedBtn{
      width: 100px;
    }
  } 
}
</style>
<style>
  .tableLib{
    display: flex;
    border: 1px solid rgba(0,0,0,.12);
    border-top: none;
  }
  .tableHead{
    font-weight: 600;
    border-top: 1px solid rgba(0,0,0,.12);
  }
  .tableItem{
    flex-grow: 1;
    border-right: 1px solid rgba(0,0,0,.12);
    flex-basis: 100px;
    text-align: center
  }
  .tableItem:first-child{
    flex-basis: 45px;
    flex-grow: 0
  }
  .tableItem:nth-child(2){
    flex-basis: 150px;
  }
  .tableItem:last-child{
    border: none
  }
</style>

